import React, { Component, Fragment } from 'react';
import { Grid, Header, Button, Segment, Loader, Dimmer, Message, List } from 'semantic-ui-react';
import CustomFieldHeader from '../CustomFields/CustomFieldHeader';
import CustomField from '../CustomFields/CustomField';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { customFieldEdited, showLoading } from '../../actions/customFields/editCustomFields';
import { fetchAllCustomFeilds } from '../../actions/customFields/fetchAllCustomFields';
import { resetCustomField, saveCustomField } from '../../actions/customFields/saveAndCancelCustomField';
import CustomFieldConfirmModal from './CustomFieldConfirmModal';
import { createNotification, NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_WARNING } from 'react-redux-notify';

var userDetails = atob(localStorage.getItem("userDetails"));
if (userDetails) {
    try {
        userDetails = JSON.parse(userDetails);
    }
    catch (e) {
        console.error('Invalid JSON input:', e.message);
    }
}
const firmID = userDetails ? userDetails.UserContext.firmId : 697;
var loggedInUserId = userDetails ? userDetails.UserContext.userId : 16192;

class CustomFields extends Component {
    constructor() {
        super();

        this.successNotification = {
            type: NOTIFICATION_TYPE_SUCCESS,
            duration: 5000,
            canDismiss: true,
        }
        this.errorNotification = {
            type: NOTIFICATION_TYPE_ERROR,
            duration: 5000,
            canDismiss: true,
        }

    }
    componentDidMount() {
        let self = this;
        window.onbeforeunload = () => {
            if (self.props.isCfieldsedited) {
                return "";
            }
        }
        this.props.fetchAllCustomFeilds(firmID);
    }

    onClickSaveHandler = () => {

        var _this = this;
        let emptyOptionsCount = 0;
        this.props.firmCustomFields.map(element => {
            element.fieldName = element.fieldName.trim();
            element.updatedBy = loggedInUserId;
            if (element.fieldType === 'Single Select' && element.customFieldOptions.length === 0) {
                emptyOptionsCount++;
            }
            return element;
        });
        let _emptyField = this.props.firmCustomFields.filter(cField => cField.fieldName.trim() === "");
        let _uniqFieldName = [...new Set(this.props.firmCustomFields.map(cField => cField.fieldName.trim()))];

        if (_emptyField.length) {
            const blankCfieldNotification = {
                message: `There must be a Custom Field Name.`,
                ...this.errorNotification
            }
            this.props.createNotification(blankCfieldNotification);
        } else if (_uniqFieldName.length < this.props.firmCustomFields.length) {
            const existsNotification = {
                message: `Custom Field Name already exists`,
                ...this.errorNotification
            }
            this.props.createNotification(existsNotification);
        } else if (emptyOptionsCount !== 0) {
            const mustOptionNotification = {
                message: `All dropdown fields must have one or more options.`,
                ...this.errorNotification
            }
            this.props.createNotification(mustOptionNotification);
        }
        else {
            this.props.showLoading(true);
            const saveNotification = {
                message: `Saved Successfully`,
                ...this.successNotification
            }
            let savePromise = this.props.saveCustomField(this.props.firmCustomFields, firmID);
            savePromise.then((response) => {
                if (response.statusCode === 200) {
                    _this.props.createNotification(saveNotification);
                    _this.props.showLoading(false);
                }
            }).catch((response) => {
                console.log('error in saving the data', response)
            });
        }
    }

    onClickCancelHandler = () => {
        this.props.resetCustomField(this.props.originalFirmCustomFields);
        const discardNotification = {
            message: `Changes Discarded Successfully`,
            ...this.successNotification
        }
        this.props.createNotification(discardNotification);
    }


    render() {
        return (
            <Fragment>
                {!this.props.firmCustomFields.length || this.props.showLoadingMessage ? (
                    <Dimmer active inverted page>
                        <Loader inverted>Loading</Loader>
                    </Dimmer>
                ) : (<div />)
                }
                <Segment basic>
                    <Grid
                        columns={1}
                        padded
                        verticalAlign="middle"
                    >
                        <Grid.Row columns={1}>
                            <Grid.Column>
                                <CustomFieldHeader />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <Grid>
                        <Grid.Row columns={2} >
                            <Grid.Column width={10}>
                                <Grid padded verticalAlign='middle'>

                                    <Grid.Row columns={5} >
                                        <Grid.Column width={5}>
                                            <Header as='h5'>Field Name</Header>
                                        </Grid.Column >
                                        <Grid.Column width={3}>
                                            <Header as='h5'>Field Type</Header>
                                        </Grid.Column>
                                        <Grid.Column width={2}>
                                            <Header as='h5'>Display</Header>
                                        </Grid.Column>
                                        <Grid.Column width={2}>
                                            <Header as='h5'>Recurring and Rollover</Header>
                                        </Grid.Column>
                                        <Grid.Column width={1}>
                                        </Grid.Column>
                                    </Grid.Row>
                                    {
                                        this.props.firmCustomFields.map(customField => {
                                            return <CustomField key={customField.fieldID} customField={customField} />
                                        })
                                    }
                                    {
                                        this.props.isCfieldsedited ? (
                                            <Grid.Row>
                                                <Grid.Column width={4}>
                                                    <Button primary onClick={this.onClickSaveHandler.bind(this)}>
                                                        Save
                                                    </Button>
                                                    {/* <CustomFieldConfirmModal /> 
                                                    */}
                                                    <Button onClick={this.onClickCancelHandler.bind(this)}>
                                                        Cancel
                                                    </Button>


                                                </Grid.Column>
                                            </Grid.Row>) : ""
                                    }
                                </Grid>
                            </Grid.Column>
                            <Grid.Column width={6}>
                                <Message info>
                                    <Message.Header> Note : </Message.Header>
                                    <List bulleted>
                                        <List.Item>Changes made to Custom Fields will be reflected in the Manage Custom Grid settings.</List.Item>
                                        <List.Item>Changes made to these fields will be reflected in the next session after you log out.</List.Item>
                                        <List.Item>Single Select Dropdown cannot be changed if there is data present in the Control Sheet.</List.Item>
                                    </List>
                                </Message>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            </Fragment>
        );
    }
}
function mapStatetoprops(state) {
    return {
        isCfieldsedited: state.customFieldsReducer.isCustomFieldEdited,
        firmCustomFields: state.customFieldsReducer.firmCustomFields,
        originalFirmCustomFields: state.customFieldsReducer.originalFirmCustomFields,
        createNotification: state.customFieldsReducer.createNotification,
        showLoadingMessage: state.customFieldsReducer.isCustomFieldLoading
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            customFieldEdited,
            fetchAllCustomFeilds,
            resetCustomField,
            saveCustomField,
            createNotification,
            showLoading
        },
        dispatch
    )
}

export default connect(mapStatetoprops, mapDispatchToProps)(CustomFields);